import { HttpResult } from "widgets-for-react";
import { ApiException, ErrorResponse } from "./generated";

export declare type ExtendedHttpResult<a> = HttpResult<a> | ({
  kind: "failedWithMessage"
  message: string
} & {
  status: number
})

export const isErrorResponse = (object: any): object is ErrorResponse => {
  return object && object['Status'] === 'Error';
}

export const httpResult = async <T>(promise: () => Promise<T>): Promise<HttpResult<T>> => {
  try {
    return {
      kind: 'result',
      value: await promise(),
      status: 200
    }
  } catch (error) {
    if (isErrorResponse(error)) return { kind: 'failed', status: error.HttpStatusCode }
    if (ApiException.isApiException(error)) return { kind: 'failed', status: error.status }
    console.error(error);
    return {
      kind: 'failed',
      status: 500
    }
  }
};

export const extendedHttpResult = async <T>(promise: () => Promise<T>): Promise<ExtendedHttpResult<T>> => {
  try {
    return {
      kind: 'result',
      value: await promise(),
      status: 200
    }
  } catch (error) {
    if (isErrorResponse(error)) return {
      kind: 'failedWithMessage',
      message: error.Message,
      status: error.HttpStatusCode
    }
    if (ApiException.isApiException(error)) return {
      kind: 'failedWithMessage',
      message: error.message,
      status: error.status
    }
    console.error(error);
    return {
      kind: 'failed',
      status: 500
    }
  }
};